<div class="excel-upload-error-modal modal-content-radius-16">
  <!-- Header with Gradient matching design language -->
  <div class="modal-header">
    <h5 class="modal-title">{{ data.title }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <!-- Success count banner -->
    <div
      *ngIf="successCount > 0"
      class="alert alert-success d-flex align-items-center mb-0"
    >
      <i class="fas fa-check-circle mr-2"></i>
      <span
        ><strong>{{ successCount }}</strong> item(s) updated successfully out of
        {{ totalCount }}.</span
      >
    </div>

    <!-- Error/Warning List -->
    <ng-container *ngIf="!isLoading; else loadingTpl">
      <div class="content-card content-card--issue-list">
        <kendo-grid
          [data]="issues"
          [height]="gridHeight"
          [scrollable]="'virtual'"
          [rowClass]="rowCallback"
          class="custom-kendo-grid"
        >
          <!-- Line Column -->
          <kendo-grid-column
            field="csvLine"
            title="LINE"
            [width]="80"
            [headerClass]="'col-line-header'"
            [class]="'col-line-cell'"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="line-pill">#{{ dataItem.csvLine }}</span>
            </ng-template>
          </kendo-grid-column>

          <!-- Identity Column -->
          <kendo-grid-column field="sku" title="IDENTIFYING INFO" [width]="300">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="identity-wrapper">
                <ng-container *ngFor="let identity of dataItem.identities; let last = last">
                  <div
                    *ngIf="identity.mainText && identity.mainText !== '—'"
                    class="identity-row"
                    [class.mb-1]="!last"
                    [attr.title]="identity.isMetadata ? (identity.label + ': ' + identity.tagText) : null"
                  >
                    <i
                      class="fas"
                      [ngClass]="identity.icon"
                      [class.text-danger]="dataItem.type === 'error'"
                      [class.text-warning]="dataItem.type === 'warning'"
                    ></i>
                    <span
                      class="identity-main"
                      [class.text-muted]="identity.isMetadata"
                    >
                      {{ identity.mainText }}
                    </span>
                    <span *ngIf="identity.tagText && !identity.isMetadata" class="identity-tag">
                      {{ identity.label }}: {{ identity.tagText }}
                    </span>
                  </div>
                </ng-container>
              </div>
            </ng-template>
          </kendo-grid-column>

          <!-- Issue Column -->
          <kendo-grid-column field="message" title="ISSUE">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="message-text">{{ dataItem.message }}</div>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>

      <div class="error-footer" *ngIf="reportLink || hintMessage">
        <p *ngIf="hintMessage" class="hint-message">{{ hintMessage }}</p>
        <div class="error-footer-actions">
          <a
            *ngIf="reportLink"
            href="javascript:"
            (click)="downloadErrors()"
            class="download-link"
          >
            <i class="fas fa-download"></i> Download full error report
          </a>
          <button
            type="button"
            class="btn btn-secondary ml-auto"
            (click)="onClose()"
          >
            Close
          </button>
        </div>
      </div>
    </ng-container>

    <ng-template #loadingTpl>
      <div class="content-card text-center py-5">
        <i class="fas fa-spinner fa-spin fa-2x mb-3 text-primary"></i>
        <p class="mb-0">Loading issues...</p>
      </div>
    </ng-template>
  </div>
</div>
